import { logoutAction, setLoadingAction } from '../actions';
import { resetAllSlices } from '../Providers/mainStore.slice';
import { mainStore } from '../Providers/mainStore';

export const dispatchUtil = {
  isReady: false,
  dispatch: () => {
    console.error('store is NOT ready');
  },
};

export const notificationDispatchUtil = {
  isReady: false,
  dispatch: () => {
    console.error('notificationStore is NOT ready');
  },
};

export const logoutUtil = () => {
  dispatchUtil.dispatch(setLoadingAction(true));
  dispatchUtil.dispatch(logoutAction());
  notificationDispatchUtil.dispatch(logoutAction());
  mainStore.dispatch(resetAllSlices());
};
